import {
  AfterViewChecked,
  ChangeDetectorRef,
  Component,
  ElementRef,
  Input,
  OnChanges,
  OnDestroy,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { NavigationEnd, Router, RouterEvent, Scroll } from '@angular/router';

import { HeaderMenu } from '../../seds-header/models/header-menu';
import { filter, map } from 'rxjs';

@Component({
    selector: 'seds-header-menu',
    templateUrl: './seds-header-menu.component.html',
    styleUrls: ['./seds-header-menu.component.scss'],
    standalone: false
})
export class SedsHeaderMenuComponent implements AfterViewChecked, OnChanges, OnDestroy {
  @Input()
  headerMenuList!: HeaderMenu[];

  @ViewChild('navHeader')
  navHeaderEl!: ElementRef;

  @ViewChild('menuItens')
  menuItemEl!: ElementRef;

  currentUrl = '';
  endPosition = false;
  hasScroll = false;
  startPosition = true;
  subscription: any;

  private readonly moveInterval = 80;
  private scrollSize = 0;
  private readonly window!: Window;

  constructor(private readonly cd: ChangeDetectorRef, private readonly router: Router) {
    this.setSubscription();
  }

  ngAfterViewChecked() {
    this.scrollSize = this.menuItemEl.nativeElement.scrollWidth - this.menuItemEl.nativeElement.offsetWidth;
    this.hasScroll = this.hasScrollButtons();

    this.cd.detectChanges();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['headerMenuList'] && this.headerMenuList) {
      this.updateSelectedButton(this.currentUrl);
    }
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  setSubscription() {
    this.subscription = this.router.events
      .pipe(
        filter(
          event =>
            event instanceof NavigationEnd || (event instanceof Scroll && event.routerEvent instanceof NavigationEnd)
        ),
        map(event => (event instanceof Scroll ? (event.routerEvent as NavigationEnd) : (event as NavigationEnd)))
      )
      .subscribe(event => {
        if (event instanceof RouterEvent && this.currentUrl !== event.url) {
          this.updateSelectedButton(event.url);
          this.currentUrl = event.url;
        }
      });
  }

  get scrollPosition(): number {
    return this.menuItemEl.nativeElement.scrollLeft;
  }

  set scrollPosition(value: number) {
    this.menuItemEl.nativeElement.scrollLeft = value;
  }

  updateScrollToLeft(): void {
    this.updateSizes();
    if (this.scrollPosition > 0) {
      const result = this.scrollPosition - this.moveInterval > 0 ? this.scrollPosition - this.moveInterval : 0;
      this.menuItemEl.nativeElement.scrollTo({ left: result, top: 0, behavior: 'smooth' });
      this.updateScrollButtons(result);
    }
  }

  updateScrollToRight(): void {
    this.updateSizes();

    if (this.scrollPosition < this.scrollSize) {
      const result =
        this.scrollPosition + this.moveInterval > this.scrollSize
          ? this.scrollSize
          : this.scrollPosition + this.moveInterval;
      this.menuItemEl.nativeElement.scrollTo({ left: result, top: 0, behavior: 'smooth' });
      this.updateScrollButtons(result);
    }
  }

  navigate(menu: any): void {
    if (menu.url && menu.url !== '') {
      window.location.href = menu.url;
    } else if (menu.routerLink && menu.routerLink !== '') {
      this.router.navigate([menu.routerLink]);
    }
  }

  acessibiltyOverlay(index: number, open: boolean) {
    this.headerMenuList[index].isOpen = open;
  }

  private hasScrollButtons(): boolean {
    if (this.scrollSize > 0) {
      return true;
    } else {
      return false;
    }
  }

  private updateScrollButtons(scrollCurrentPosition: number): void {
    if (scrollCurrentPosition === 0) {
      this.startPosition = true;
      this.endPosition = false;
    } else if (scrollCurrentPosition > 0 && scrollCurrentPosition < this.scrollSize) {
      this.startPosition = false;
      this.endPosition = false;
    } else if (scrollCurrentPosition === this.scrollSize) {
      this.startPosition = false;
      this.endPosition = true;
    }
  }

  private updateSizes(): void {
    this.scrollSize = this.menuItemEl.nativeElement.scrollWidth - this.menuItemEl.nativeElement.offsetWidth;
  }

  private updateSelectedButton(url: string): void {
    if (this.headerMenuList) {
      this.headerMenuList.forEach(menu => {
        if (menu.routerLink && url.includes(menu.routerLink) && menu.routerLink !== '') {
          menu.isSelected = true;
        } else {
          menu.isSelected = false;
        }
      });
    }
  }
}
